/**
 * @param {HTMLElement} element
 */
export default function clearElement(element) {
  if (element && element.children) {
    while (element.children.length > 0) {
      element.removeChild(element.children[0]);
    }
  }
}
